import { Component, inject } from '@angular/core';

import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {FullButtonComponent} from "../full-button/full-button.component";
import {OutlineButtonComponent} from "../outline-button/outline-button.component";

export enum DIALOG_ACTION_STYLE {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WARNING = 'warning',
  SUCCESS = 'success',
  DANGER = 'danger',
}

export interface DialogAction {
  label: string;
  style: DIALOG_ACTION_STYLE;
  action: () => string;
}

export interface ConfirmDialogData {
  title?: string;
  message?: string;
  button_actions?: DialogAction[];
}

@Component({
    selector: 'app-confirm-dialog',
    imports: [FullButtonComponent, OutlineButtonComponent],
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {
  dialogRef: DialogRef<string> = inject(DialogRef);
  data: ConfirmDialogData = inject(DIALOG_DATA);

  onButtonClick(action: () => string) {
    this.dialogRef.close(action());
  }
}
